import * as React from "react";

import { useProvidedState } from "@shared-ui/provided-state-context";

import { FlexComponent } from "typings/flexFramework/FlexComponent";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

import { ClientWizardStateStore } from "stores/wizard/ClientWizardStateStore";
import { WizardWithHeroImage } from "./components/WizardWithHeroImage";
import { WizardForTripsHero } from "./components/WizardForHeroTrips";

export interface WizardHeroProps {
  isStorefrontPage: boolean;
  wizardLOBs: FlexComponent[];
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tabName: string, rfrrId?: string) => void;
  context: ExtendedContextStore;
  heroImageFigureClassNames: string;
  heroImageSrc: string;
  isSingleLobWithTitle: boolean;
  wizardState: ClientWizardStateStore;
  cardClass: string;
}

export const WizardHero: React.FC<WizardHeroProps> = (props) => {
  const [data] = useProvidedState();

  if (data?.tripsHero?.isRendered) {
    return <WizardForTripsHero {...props} />;
  }

  return <WizardWithHeroImage {...props} />;
};
